import mitt from 'mitt'
import { defineNuxtPlugin } from '@nuxtjs/composition-api'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default defineNuxtPlugin((ctx, inject) => {
  const emitter = mitt()
  inject('bus', emitter)
})
